import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	isSidebarOpen: false,
}

const sidebarSlice = createSlice({
	name: 'sidebar',
	initialState,
	reducers: {
		toggleSidebar: (state) => {
			state.isSidebarOpen = !state.isSidebarOpen
			if (state.isSidebarOpen) {
				document.body.classList.add('sidebar-expand')
			} else {
				document.body.classList.remove('sidebar-expand')
			}
		},
	},
})

export const { toggleSidebar } = sidebarSlice.actions
export default sidebarSlice.reducer
